import { requireStringField, optionalStringField } from "./ReplayPayloadValidation";
import { parseBinaryMaskToIndices } from "./MaskParsing";

/**
 * Validation + parsing for "present_scatter_state".
 *
 * Payload:
 * - positionMask (required)
 * - scatterCount (required)
 * - scatterSymbolIdentifier (optional)
 */
export function parsePresentScatterStatePayload(actionTypeName: string, payload: Record<string, unknown>): {
  positionMask: string;
  scatterCount: string;
  scatterSymbolIdentifier?: string;
  indices: number[];
} {
  const positionMask = requireStringField(actionTypeName, payload, "positionMask");
  const scatterCount = requireStringField(actionTypeName, payload, "scatterCount");
  const scatterSymbolIdentifier = optionalStringField(payload, "scatterSymbolIdentifier");

  const indices = parseBinaryMaskToIndices(actionTypeName, "positionMask", positionMask);

  return { positionMask, scatterCount, scatterSymbolIdentifier, indices };
}